import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/promocategory`;


const ApiPromoCategory = {
  getAll: (params) => {
    const url = `${baseServiceUrl}`;
    return ServiceApi.get(url, { params });
  },
  getAllPromoCategory: () => {
    const url = `${baseServiceUrl}/getPromoCategoryList`;
    return ServiceApi.get(url);
  },
  GetPromoCategoryAmusementServiceById: (params) => {
    const url = `${baseServiceUrl}/GetPromoCategoryAmusementServiceById/${params}`;
    return ServiceApi.get(url);
  },
  GetPromoCategoryById: (params) => {
    const url = `${baseServiceUrl}/${params}`;
    return ServiceApi.get(url);
  },
  addOrEditPromoCategory: (params) => {
    const url = `${baseServiceUrl}/addoreditpromocategory`;
    return ServiceApi.post(url, params);
  },
  updatePromoCategoryStatus: (params) => {
    const url = `${baseServiceUrl}/updatePromoCategoryStatus`;
    return ServiceApi.put(url, params);
  },
  addOrEditPromoCategoryAmusmentService: (params) => {
    const url = `${baseServiceUrl}/addOrEditPromoCategoryAmusmentService`;
    return ServiceApi.post(url, params);
  },
  addOrEditPromoCategoryAmusmentServiceByExcel: (formData) => {
    const url = `${baseServiceUrl}/addOrEditPromoCategoryAmusmentServiceByExcel`;
    return ServiceApi.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  update: (id, data) => {
    const url = `${baseServiceUrl}/update-amusementGroup`;
    return ServiceApi.put(url, data);
  },
  delete: (id) => {
    const url = `${baseServiceUrl}/${id}`;
    return ServiceApi.delete(url);
  },
  getAllGroups: () => {
    const url = `${baseServiceUrl}/getAllAmusementGroups`;
    return ServiceApi.get(url);
  },
  getPromoCategoryType: (params) => {
    const url = `${baseServiceUrl}/getPromoCategoryType`;
    return ServiceApi.get(url, params);
  },
  getAllPromoCategoryByAgentId: (params) => {
    const url = `${baseServiceUrl}/getAllPromoCategoryByAgentId/${params.id}`;
    delete params.id
    return ServiceApi.get(url, { params });
  },
  copyPromoCategory: (params) => {
    const url = `${baseServiceUrl}/CopyPromoCategory`;
    return ServiceApi.post(url, params);
  },
  getAllPromoCategoryAndCommission: () => {
    const url = `${baseServiceUrl}/getAllPromoCategoryAndCommission`;
    return ServiceApi.get(url);
  },
  addPromoCategoryAmusementServiceByReserveItemId: (params) => {
    const url = `${baseServiceUrl}/addPromoCategoryAmusementServiceByReserveItemId`;
    return ServiceApi.put(url, params);
  },
};

export default ApiPromoCategory;